function beforeAfterSlider() {
  $(document).ready(function() {
    if ($('#before_after_slider').length) {
      const slideCount = $('#before_after_slider .splide__slide').length;

      var splideSlider = new Splide('#before_after_slider', {
        type: 'slide',
        perPage: 1,
        focus: 'center',
        autoplay: false,
        arrows: slideCount > 1,
        rewind: slideCount > 1,
        label: 'Before/After slider',
        labelledby: 'Before/After slider',
        role: 'banner',
        draggable: slideCount > 1,
        fixedWidth: false,
        pagination: false,
        breakpoints: {
          998: {
            pagination: slideCount > 1,
            fixedWidth: false,
            autoWidth: true,
            gap: '15px'
          },
          768: {
            pagination: slideCount > 1,
            fixedWidth: '100%',
            autoWidth: false,
            gap: '0'
          }
        }
      });

      splideSlider.mount();

      // ZOOM & Hover effects on images
      document.querySelectorAll('.before-after-images-container').forEach((container) => {

        const beforeImg = container.querySelector('.before img');
        const afterImg = container.querySelector('.after img');

        const beforeContainer = container.querySelector('.before');
        const afterContainer = container.querySelector('.after');

        const zoomInBtn = container.querySelector('.zoom-in');
        const zoomOutBtn = container.querySelector('.zoom-out');

        let scale = 1;

        const MIN_ZOOM = 1;
        const MAX_ZOOM = 3;
        const ZOOM_STEP = 0.25;

        let beforeX = 0;
        let beforeY = 0;

        let afterX = 0;
        let afterY = 0;

        function updateTransforms() {

          beforeImg.style.transform = `
      translate(${beforeX}px, ${beforeY}px)
      scale(${scale})
    `;

          afterImg.style.transform = `
      translate(${afterX}px, ${afterY}px)
      scale(${scale})
    `;
        }

        // ZOOM IN
        zoomInBtn.addEventListener('click', () => {
          scale = Math.min(scale + ZOOM_STEP, MAX_ZOOM);
          updateTransforms();
        });

        // ZOOM OUT
        zoomOutBtn.addEventListener('click', () => {

          scale = Math.max(scale - ZOOM_STEP, MIN_ZOOM);

          if (scale === 1) {

            beforeX = 0;
            beforeY = 0;

            afterX = 0;
            afterY = 0;
          }

          updateTransforms();
        });

        // BEFORE HOVER
        beforeContainer.addEventListener('mousemove', (e) => {

          if (scale <= 1) return;

          const rect = beforeContainer.getBoundingClientRect();

          const percentX = ((e.clientX - rect.left) / rect.width) - 0.5;
          const percentY = ((e.clientY - rect.top) / rect.height) - 0.5;

          const moveAmount = 120;

          beforeX = -(percentX * moveAmount);
          beforeY = -(percentY * moveAmount);

          updateTransforms();
        });

        // AFTER HOVER
        afterContainer.addEventListener('mousemove', (e) => {

          if (scale <= 1) return;

          const rect = afterContainer.getBoundingClientRect();

          const percentX = ((e.clientX - rect.left) / rect.width) - 0.5;
          const percentY = ((e.clientY - rect.top) / rect.height) - 0.5;

          const moveAmount = 120;

          afterX = -(percentX * moveAmount);
          afterY = -(percentY * moveAmount);

          updateTransforms();
        });

        // RESET BEFORE
        beforeContainer.addEventListener('mouseleave', () => {

          beforeX = 0;
          beforeY = 0;

          updateTransforms();
        });

        // RESET AFTER
        afterContainer.addEventListener('mouseleave', () => {

          afterX = 0;
          afterY = 0;

          updateTransforms();
        });

        [beforeImg, afterImg].forEach((img) => {

          img.style.transition = 'transform 0.25s ease';
          img.style.transformOrigin = 'center center';
          img.style.willChange = 'transform';

        });

      });
    }
  });
}
